// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"App_cardContainer__2YSdb"};